module.exports = __webpack_public_path__ + "static/media/bg-reset.242cf6cd.jpg";